import type { HomeChartProps } from "./types-home-chart";
import { useHomeChart } from "./use-home-chart";
import { HomeChartView } from "./view-home-chart";

export function HomeChart(props: HomeChartProps) {
  const vm = useHomeChart(props);
  const { ariaLabel, labelHeader, valueHeader, className, testId } = props;

  return (
    <HomeChartView
      {...vm}
      ariaLabel={ariaLabel}
      labelHeader={labelHeader}
      valueHeader={valueHeader}
      className={className}
      testId={testId}
    />
  );
}

export type * from "./types-home-chart";
